import {
  getGetFeatureUsagesQueryKey,
  useGetFeatureUsages,
} from '@modusign/openapi-client-subscription';

import { AuthorityResource } from '@app/features/subscription/types/AuthorityResource';
import { useWorkspaceId } from '@app/hooks/useWorkspaceId';

export const getAuthorityQueryKey = getGetFeatureUsagesQueryKey;

export default function useAuthority(options?: { suspense?: boolean }) {
  const workspaceId = useWorkspaceId();

  return useGetFeatureUsages(workspaceId, {
    query: {
      queryKey: getAuthorityQueryKey(workspaceId),
      select: (data) => {
        const permissions: UserAuthorityPermissionsState = { ...initialPermissions };

        if (data) {
          data.permissions.forEach((p) => {
            if (p.id) {
              permissions[p.resource] = true;
            }
          });
        }

        return { period: data?.period || null, permissions };
      },
      staleTime: 1000 * 60 * 5,
      ...options,
    },
  });
}

type UserAuthorityPermissionsState = Record<AuthorityResource, boolean>;

const initialPermissions: UserAuthorityPermissionsState = {
  ADDRESS_BOOK: false,
  API: false,
  APPROVAL: false,
  BULK_REQUEST: false,
  CUSTOM_BRANDING_EMAIL: false,
  CUSTOM_BRANDING_KAKAO_CHANNEL: false,
  DOCUMENT: false,
  DOCUMENT_REMINDER: false,
  EDITING_DOCUMENT: false,
  EXPORT_INPUT_VALUES: false,
  EXTERNAL_DOCUMENT: false,
  CONTRACT_LINK: false,
  TEMPLATE: false,
  WEBHOOK: false,
  IN_PERSON_CONTRACT: false,
  SCHEDULED_REQUEST: false,
};
